import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1 /* HOISTED */);
var _hoisted_2 = { class: "grid-doctype" };
var _hoisted_3 = { class: "grid-issuedby" };
var _hoisted_4 = { class: "grid-nationality" };
var _hoisted_5 = { class: "grid-expirydate" };
var _hoisted_6 = ["onClick"];
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-delete-fill icon--sm icon-color--red",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_8 = [
    _hoisted_7
];
var _hoisted_9 = { class: "visa-and-health-block__footer-row" };
var _hoisted_10 = { class: "add-document" };
var _hoisted_11 = ["onClick"];
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1 /* HOISTED */);
var _hoisted_13 = { class: "travel-rules" };
var _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "checkbox-field" }, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createElementVNode("input", {
            type: "checkbox",
            name: "subscribe"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createElementVNode("label", { for: "subscribe" }, [
            /*#__PURE__*/ _createElementVNode("p", { class: "checkbox-label text-KQ-White fs-14" }, " Show child travel rules ")
        ])
    ])
], -1 /* HOISTED */);
var _hoisted_15 = ["href"];
import { ref, reactive, computed, watch } from 'vue';
import ItineraryFields from '../ItineraryFields/ItineraryFields.vue';
import { useQuery } from '@tanstack/vue-query';
import optiClient from '../../services/api';
import useMatchMedia from '../../hooks/useMatchMedia';
import DropdownSelect from '../DropdownSelect/DropdownSelect.vue';
import DatePicker from '../DatePicker/DatePicker.vue';
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';
import { useElementVisibility } from '@vueuse/core';
export default /*#__PURE__*/ _defineComponent({
    __name: 'VisaAndHealth',
    props: {
        itineraries: { default: function () { return [{}, {}]; } },
        traveldocBaseUrl: { default: 'https://kenya-airways.traveldoc.aero' },
        destinationData: { default: function () { return [{}]; } }
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var el = ref(null);
        var itinerariesRef = ref(props.itineraries ? cloneDeep(props.itineraries) : [{}, {}]);
        var isDisplayed = useElementVisibility(el);
        var expiryDefaultDate = computed(function () {
            var currentDate = new Date();
            var nextYear = currentDate.getFullYear() + 1;
            var nextYearDate = new Date(nextYear, currentDate.getMonth(), currentDate.getDate());
            return [nextYearDate];
        });
        var minDate = new Date();
        var documentRows = reactive([
            { expiryDate: expiryDefaultDate.value[0] },
        ]);
        var errorMessage = ref('');
        var isLessThanDesktop = useMatchMedia("(max-width: 991px)");
        var size = computed(function () {
            if (isLessThanDesktop.value) {
                return 'small';
            }
            return 'large';
        });
        var documentTypes = useQuery({
            queryKey: ['documentTypes'],
            queryFn: function () {
                return optiClient.visaAndHealth.getApiV1VisaAndHealthGetDocumentTypes();
            },
            enabled: isDisplayed,
            refetchOnWindowFocus: false,
        }).data;
        var documentTypeOptions = computed(function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = documentTypes.value) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (type) { return ({
                label: type.name,
                value: type.documentTypeID,
            }); }).sort(function (a, b) { return a.value - b.value; })) !== null && _c !== void 0 ? _c : [];
        });
        var issuingCountries = useQuery({
            queryKey: ['issuingCountries'],
            queryFn: function () {
                return optiClient.visaAndHealth.getApiV1VisaAndHealthGetIssuingCountries();
            },
            enabled: isDisplayed,
            refetchOnWindowFocus: false,
        }).data;
        var issuingCountriesOptions = computed(function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = issuingCountries.value) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (type) { return ({
                label: type.locCountry,
                value: type.countryAlpha3,
            }); })) !== null && _c !== void 0 ? _c : [];
        });
        var nationalityCountries = useQuery({
            queryKey: ['nationalityCountries'],
            queryFn: function () {
                return optiClient.visaAndHealth.getApiV1VisaAndHealthGetNationalityCountries();
            },
            enabled: isDisplayed,
            refetchOnWindowFocus: false,
        }).data;
        var nationalityOptions = computed(function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = nationalityCountries.value) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (type) { return ({
                label: type.locCountry,
                value: type.countryAlpha3,
            }); })) !== null && _c !== void 0 ? _c : [];
        });
        var handleExpiryDate = function (date, index) {
            documentRows[index].expiryDate = date[0];
        };
        var addRow = function () {
            documentRows.push({});
        };
        var removeRow = function (index) {
            documentRows.splice(index, 1);
        };
        var isButtonDisabled = computed(function () {
            var isDisabled = false;
            itinerariesRef.value.forEach(function (itinerary) {
                if ((!itinerary.fromAirport ||
                    !itinerary.toAirport ||
                    !itinerary.departureDate) &&
                    !itinerary.ignore) {
                    isDisabled = true;
                }
            });
            documentRows.forEach(function (row) {
                if (!row.documentType ||
                    !row.issuedBy ||
                    !row.nationality ||
                    !row.expiryDate) {
                    isDisabled = true;
                }
            });
            return isDisabled;
        });
        watch(function () { return props.itineraries; }, function (newValue) {
            itinerariesRef.value = newValue ? cloneDeep(newValue) : [{}, {}];
        }, { deep: true });
        watch(function () { return props.destinationData; }, function (newValue) {
            var _a, _b;
            var itinerariesObj = [
                {
                    originLocationCode: newValue.fromDestinationCode,
                    destinationLocationCode: newValue.toDestinationCode,
                    departureDate: (_a = newValue.travelDates) === null || _a === void 0 ? void 0 : _a.split('to')[0],
                },
                {
                    originLocationCode: newValue.fromDestinationCode,
                    destinationLocationCode: newValue.toDestinationCode,
                    departureDate: (_b = newValue.travelDates) === null || _b === void 0 ? void 0 : _b.split('to')[1],
                }
            ];
            itinerariesRef.value = itinerariesObj
                ? cloneDeep(itinerariesObj)
                : [{}, {}];
        }, { deep: true });
        var datePickerKeys = reactive({
            depart: itinerariesRef.value.map(function () { return Date.now(); }),
            departreturn: itinerariesRef.value.map(function () { return Date.now(); }),
            expiry: documentRows.map(function () { return Date.now(); }),
        });
        var resetForm = function () {
            itinerariesRef.value = [{}, {}];
            datePickerKeys.depart = itinerariesRef.value.map(function () { return Date.now(); });
            datePickerKeys.departreturn = itinerariesRef.value.map(function () { return Date.now(); });
        };
        __expose({
            resetForm: resetForm,
        });
        var submit = function () {
            if (isButtonDisabled.value) {
                return false;
            }
        };
        var formatDate = function (date) {
            return dayjs(date).format('YYYY-MM-DD');
        };
        var queryString = computed(function () {
            var queryString = '';
            itinerariesRef.value.forEach(function (flight, index) {
                var fromAirport = flight.fromAirport, toAirport = flight.toAirport, departureDate = flight.departureDate;
                if (fromAirport && toAirport) {
                    var departDateString = departureDate
                        ? formatDate(departureDate)
                        : formatDate(minDate);
                    queryString += "S=".concat(index + 1, "|").concat(fromAirport.locIATA, "|").concat(toAirport.locIATA, "|").concat(departDateString, "&");
                }
            });
            documentRows.forEach(function (documentRow, index) {
                var documentType = documentRow.documentType, issuedBy = documentRow.issuedBy, nationality = documentRow.nationality;
                var expiryDate = documentRow.expiryDate
                    ? formatDate(documentRow.expiryDate)
                    : formatDate(minDate);
                if (issuedBy && nationality && documentType) {
                    queryString += "D=".concat(documentType.value, "|").concat(issuedBy.value, "|").concat(nationality.value, "|").concat(expiryDate, "&");
                }
            });
            queryString += 'results=true';
            return queryString;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "el",
                ref: el,
                class: "visa-and-health-block"
            }, [
                _createVNode(ItineraryFields, {
                    itineraries: itinerariesRef.value,
                    "onUpdate:itineraries": _cache[0] || (_cache[0] = function ($event) { return ((itinerariesRef).value = $event); }),
                    size: size.value,
                    "allow-multi-city": "",
                    "show-dates": "",
                    "conditional-second-row": false,
                    "show-cabin-class": false
                }, null, 8 /* PROPS */, ["itineraries", "size"]),
                _hoisted_1,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentRows, function (row, index) {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(index === 0
                            ? 'visa-and-health-block__second-row'
                            : 'visa-and-health-block__second-row another-document')
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(DropdownSelect, {
                                modelValue: row.documentType,
                                "onUpdate:modelValue": function ($event) { return ((row.documentType) = $event); },
                                dropdownTitle: "Document type",
                                name: "doctype",
                                classes: "doctype",
                                "aria-label": "Select document type",
                                optionsArray: documentTypeOptions.value
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "optionsArray"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(DropdownSelect, {
                                modelValue: row.issuedBy,
                                "onUpdate:modelValue": function ($event) { return ((row.issuedBy) = $event); },
                                name: "issuedby",
                                classes: "issuedby",
                                dropdownLabel: "Issued by",
                                optionsArray: issuingCountriesOptions.value
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "optionsArray"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(DropdownSelect, {
                                modelValue: row.nationality,
                                "onUpdate:modelValue": function ($event) { return ((row.nationality) = $event); },
                                dropdownLabel: "Nationality",
                                name: "nationality",
                                classes: "nationality",
                                optionsArray: nationalityOptions.value
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "optionsArray"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(), _createBlock(DatePicker, {
                                key: datePickerKeys.expiry[index],
                                defaultValue: expiryDefaultDate.value,
                                minDate: _unref(minDate),
                                name: "expiryDatePicker",
                                label: "Expiry Date",
                                required: "",
                                "onUpdate:date": function (date) { return handleExpiryDate(date, index); }
                            }, null, 8 /* PROPS */, ["defaultValue", "minDate", "onUpdate:date"])),
                            (index > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    role: "button",
                                    "aria-label": "Remove row",
                                    class: "button button--text button--icon",
                                    onClick: function ($event) { return (removeRow(index)); }
                                }, _hoisted_8, 8 /* PROPS */, _hoisted_6))
                                : _createCommentVNode("v-if", true)
                        ])
                    ], 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("a", {
                            href: "#",
                            class: "fs-14 text-KQ-White add-document-button",
                            onClick: _withModifiers(addRow, ["prevent"])
                        }, " + Add documents ", 8 /* PROPS */, _hoisted_11)
                    ]),
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("a", {
                            "aria-label": "Optional description of what happens when the link is clicked",
                            class: _normalizeClass([
                                'button button--primary button--lg',
                                {
                                    disabled: isButtonDisabled.value,
                                },
                            ]),
                            href: "".concat(_ctx.traveldocBaseUrl, "/?").concat(queryString.value),
                            rel: "noopener",
                            target: "_blank",
                            onClick: submit
                        }, " Submit ", 10 /* CLASS, PROPS */, _hoisted_15)
                    ])
                ])
            ], 512 /* NEED_PATCH */));
        };
    }
});
